import BaseAPI, { newIdempotencyKey } from './BaseAPI';

// The shift log — clock in, clock out — under /shifts.
class ShiftsAPI extends BaseAPI {
  constructor() { super('shifts'); }

  // GET /shifts?start=&end=&idStaff= → { range, shifts, staff, totals }
  list(start, end, idStaff) {
    const q = new URLSearchParams();
    if (start) q.set('start', start);
    if (end) q.set('end', end);
    if (idStaff) q.set('idStaff', idStaff);
    return this.get(`/?${q.toString()}`);
  }

  // GET /shifts/open → { shifts: [...] } — everyone on the clock now.
  open() { return this.get('/open'); }

  // GET /shifts/open/:idStaff → { shift } or { shift: null }
  openFor(idStaff) { return this.get(`/open/${idStaff}`); }

  // POST /shifts/clock-in → { ok, shift }
  //
  // One key per press, so a request the browser retries by itself returns the
  // shift it already opened instead of opening a second. A genuine second
  // press gets its own key and opens a genuine second shift — the database's
  // one-open-shift-per-person index is what stops a double tap, not this.
  clockIn(idStaff, location, note) {
    return this.post('/clock-in', {
      body: { idStaff, location, note, idempotencyKey: newIdempotencyKey(`in:${idStaff}`) },
    });
  }

  // POST /shifts/clock-out → { ok, shift }
  clockOut({ idShift, idStaff, note } = {}) {
    return this.post('/clock-out', { body: { idShift, idStaff, note } });
  }

  // PUT /shifts/:idShift — archives the row and writes a corrected one.
  correct(idShift, patch) { return this.put(`/${idShift}`, { body: patch }); }

  // DELETE /shifts/:idShift — takes a clock entry off the sheet (archived).
  remove(idShift) { return this.delete(`/${idShift}`); }
}

export const ShiftsService = new ShiftsAPI();
export default ShiftsAPI;
